import * as $ from "sanctuary-def";

const field =
  (type) =>
  (sourceKey, destKey, isSubSchema = false, subSchemaIsArray, subSchema) => ({
    type,
    sourceKey,
    destKey: destKey || sourceKey,
    isSubSchema,
    subSchemaIsArray,
    subSchema,
  });

// sub-schema fields (for nested schemas)
export const schemaField = (schema) => (sourceKey, destKey) =>
  field($.Object)(sourceKey, destKey || sourceKey, true, false, schema);

export const schemaArrayField = (schema) => (sourceKey, destKey) =>
  field($.Array($.Object))(sourceKey, destKey || sourceKey, true, true, schema);

// non-schema fields
export const stringField = field($.String);
export const stringArrayField = field($.Array($.String));
export const recordArrayField = (recordType) => field($.Array(recordType));
export const booleanField = field($.Boolean);
export const positiveIntField = field($.PositiveInteger);
export const numberField = field($.Number);
export const recordField = (recordType) => field(recordType);
export const objectArrayField = field($.Array($.Object));
